import React from 'react';
import { Col, Form, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import Helpers from 'helpers';
import { renderGroupedShopOptions } from 'components/shopOptions';

const InfoSection = ({ shops, inactiveShops, isNew }) => {
  const { t } = useTranslation();

  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Info')}</Typography.Title>
      </Col>
      <Col span={9}>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item
          label={t('Insegna')}
          name='company_id'
          optionFilterProp={'label'}
        >
          <Select
            disabled={!isNew}
            placeholder={t('Insegna')}
            {...Helpers.addSearchProps()}
          >
            {renderGroupedShopOptions({
              shops,
              inactiveShops,
              t,
            })}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default InfoSection;
